'use client';

import { FC } from 'react';
import { StepFormError } from 'src/steps-form/components/StepFormError/StepFormError';
import { ErrorPageProps } from 'src/types/appRouter.types';

const ErrorForm: FC<ErrorPageProps> = (props) => (
  <StepFormError {...props} exceptionDescription="Submission error in auth form" />
);

export default ErrorForm;
